export class ItemContextFactory {
    static create(itemContext: ICatalogItemContext): IContentAPIItemContext {
        return new ItemContext(itemContext).serialize();
    }
}

export class ItemContext {
    protected _countryOfOrigin: string | undefined;
    protected _merchandising: Array<ItemMerchandisingType> | undefined;

    constructor(itemContext: ICatalogItemContext) {
        this._countryOfOrigin = itemContext.countryOfOrigin;
        this._merchandising = itemContext.merchandising;
    }

    serialize(): IContentAPIItemContext {
        const itemContext: IContentAPIItemContext = {
            countryOfOrigin: this._countryOfOrigin,
            merchandising: this._merchandising
        };

        return itemContext;
    }
}

export interface IContentAPIItemContext {
    countryOfOrigin: string | undefined;
    merchandising: Array<ItemMerchandisingType> | undefined;
}
